module.exports = __webpack_public_path__ + "img/stay-exclusive-privileges.a55ef545.jpg";